export default "__VITE_ASSET__BcP2yqqE__"